
<template>
    <div>
        <div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				center-active
				active-class="mid-primary"
				color="white"
            >
                <v-tab :to="{ name: 'users' }">
					<v-icon class="me-1"> mdi-calendar-check </v-icon>
					المستخدمين
				</v-tab>
				<v-tab :to="{ name: 'roles' }">
					<v-icon class="me-1"> mdi-calendar-alert </v-icon>
					الأدوار
				</v-tab>
            </v-tabs>
        </div>

        <v-divider></v-divider>

        <router-view></router-view>
    </div>
</template>


<script>
export default {
	// name: 'Roles',

	data() {
		return {
			tabs: 0,
		};
	},
};
</script>
